<template>
  <v-content style="padding-top: 42px !important;">
    <div id="core-view">
      <v-fade-transition mode="out-in">
        <router-view />
      </v-fade-transition>
    </div>
    <core-footer v-if="$route.name !== 'Maps'" />
  </v-content>
</template>

<script>
export default {
  metaInfo () {
    return {
      title: 'Visitors Management'
    }
  }
}
</script>

<style>
#core-view {
  padding-bottom: 36px;
}
</style>
